export const abi = [
  {
    type: 'function',
    name: 'fillQuoteEthToToken',
    inputs: [
      {
        name: 'buyTokenAddress',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'target',
        type: 'address',
        internalType: 'address payable',
      },
      {
        name: 'swapCallData',
        type: 'bytes',
        internalType: 'bytes',
      },
      {
        name: 'partnerData',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'partnerFeeReceiver',
        type: 'address',
        internalType: 'address',
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'fillQuoteTokenToEth',
    inputs: [
      {
        name: 'sellTokenAddress',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'target',
        type: 'address',
        internalType: 'address payable',
      },
      {
        name: 'swapCallData',
        type: 'bytes',
        internalType: 'bytes',
      },
      {
        name: 'sellAmount',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'feePercentage',
        type: 'uint256',
        internalType: 'uint256',
      },
      {
        name: 'partnerFeeReceiver',
        type: 'address',
        internalType: 'address',
      },
      {
        name: 'permit',
        type: 'tuple',
        internalType: 'struct Permit2',
        components: [
          {
            name: 'nonce',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'deadline',
            type: 'uint256',
            internalType: 'uint256',
          },
          {
            name: 'signature',
            type: 'bytes',
            internalType: 'bytes',
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'fillQuoteTokenToToken',
    inputs: [
      { name: 'sellTokenAddress', type: 'address' },
      { name: 'buyTokenAddress', type: 'address' },
      { name: 'target', type: 'address' },
      { name: 'swapCallData', type: 'bytes' },
      { name: 'sellAmount', type: 'uint256' },
      { name: 'feeToken', type: 'uint8' },
      { name: 'partnerData', type: 'uint256' },
      { name: 'partnerFeeReceiver', type: 'address' },
      {
        name: 'permit',
        type: 'tuple',
        components: [
          { name: 'nonce', type: 'uint256' },
          { name: 'deadline', type: 'uint256' },
          { name: 'signature', type: 'bytes' },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
]
